export default __webpack_public_path__ + "static/media/deposition-banner.1a95ca71.png";